/**
 * Lo que cambia de la ficha según la especialidad de la clínica (4/11/2026).
 *
 * En oftalmología no pinta nada el «ácido hialurónico previo» de estética:
 * el mismo dato de la ficha (`ah_previo` / `ah_previo_text`, que recorren el
 * cuestionario de salud, la LOPD, la cita y los recordatorios) pasa a ser la
 * CIRUGÍA OCULAR PREVIA, que sí importa antes de operar o de un láser. Así no
 * se toca el circuito, solo lo que se pregunta y cómo se llama.
 */

export const PERFILES_OFTALMOLOGIA = ['oftalmologia', 'vistalaser'];

export function esOftalmologia(perfil) {
  return PERFILES_OFTALMOLOGIA.includes(perfil);
}

const AH_ESTETICA = {
  etiqueta: 'Ác. hialurónico previo',
  corto: 'ácido hialurónico',
  placeholder: 'Ej.: Ácido hialurónico en surcos (2023)…',
  pregunta: '¿Te has puesto alguna vez ácido hialurónico en ojeras o pómulos?',
  preguntaUsted: '¿Se ha puesto alguna vez ácido hialurónico en ojeras o pómulos?',
  detalle: '¿Dónde y cuándo? *',
  ph: 'Ej.: ojeras, hace 2 años en otra clínica…',
};

const AH_OFTALMOLOGIA = {
  etiqueta: 'Cirugía ocular previa',
  corto: 'cirugía ocular previa',
  placeholder: 'Ej.: cataratas OD (2021), LASIK en ambos ojos (2015)…',
  pregunta: '¿Te han operado alguna vez de los ojos (cataratas, láser, glaucoma, retina, párpados…)?',
  preguntaUsted: '¿Le han operado alguna vez de los ojos (cataratas, láser, glaucoma, retina, párpados…)?',
  detalle: '¿De qué y cuándo? *',
  ph: 'Ej.: cataratas del ojo derecho en 2021…',
};

/** Los textos del campo `ah_previo` para la especialidad de la clínica. */
export function textosAhPrevio(perfil) {
  return esOftalmologia(perfil) ? AH_OFTALMOLOGIA : AH_ESTETICA;
}
